import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[sdNumbersOnlyAlt]'
})
export class NumbersOnlyAltDirective {
  private readonly regex: RegExp = /^\d*$/;
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private readonly specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home'];

  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    if (event.key) {
      const keyCopy = event.key;
      const valid = this.regex.test(keyCopy);

      if (!valid) {
        event.preventDefault();
      }
    }

    return;
  }

  //Handle case that user is pasting non-numeric values
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    if (event && event.clipboardData) {
      const pastedInput: string = event.clipboardData.getData('text/plain');
      const sanitizedInput = pastedInput.replace(/\D/g, ''); // get a digit-only string
      document.execCommand('insertText', false, sanitizedInput);
    }
  }

  //Handle case that user is dragging and dropping non-numeric values
  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event && event.dataTransfer) {
      const textData = event.dataTransfer.getData('text');
      const sanitizedInput = textData.replace(/\D/g, '');
      document.execCommand('insertText', false, sanitizedInput);
    }
  }
}
